module.exports = __webpack_public_path__ + "img/industrial.1ec5703b.png";